<template>
    <div :key="guest.id">
        <Teleport to="#guest_actions">
            <v-btn test-tag="tag-55"
                text
                color="primary"
                @click="saveGuest"
                :disabled="!guest_info_valid"
            >
                <v-icon>mdi-content-save</v-icon>
                <T>Сохранить</T>
            </v-btn>
            <deleteGuestDialog :title="$t('Удаление гостя')" 
                @onSubmit="deleteGuest" :btn_text="$t('Удалить')" 
                color="error" text
            >
                <template #body>
                    <T>Гость {{ guest.name }} будет удален.</T><br><T>Вы хотите удалить гостя?</T>
                </template>
            </deleteGuestDialog>
            
            <deleteGuestDialog
                :title="guest.black_list ? $t('Разблокировать гостя'): $t('Блокировка гостя')"
                :btn_text="guest.black_list ? $t('Разблокировать'): $t('Заблокировать')"
                btn_icon="mdi-account-cancel-outline"
                color="grey darken-4" text
                @onSubmit="blockGuest"
            >
                <template #body>
                    <!-- FIXME: Нужно пояснение написать, что будет при блокировке и разблокировке -->
                    <TextField v-if="!guest.black_list" multiline hide-details 
                        hint @focus.prevent="e => $store.dispatch('inputFocus', e)" 
                        kbd-capitalized :label="$t('Причины блокировки')" 
                        v-model="guest.block_reasons" :original_value="original_value.block_reasons"
                    />
                    <div v-else>
                        <T>Вы уверены, что хотите разблокировать {{ guest.name }}?</T>
                        <span><T>Блокировка произошла по причине:</T>{{ guest.block_reasons }}</span>
                    </div>
                </template>
            </deleteGuestDialog>
        </Teleport> 
        
        <v-card-text v-if="loading">
            <v-row class="mb-1">
                <v-col v-if="guest.black_list" cols="12">
                    <v-alert type="error">
                        <T>Причина блокировки: </T>{{ guest.block_reasons }}
                    </v-alert>
                </v-col>
                <v-col>
                    <v-form @submit.prevent="submit" v-model="guest_info_valid">
                        <TextField hint @focus.prevent="e => $store.dispatch('inputFocus', e)" kbd-capitalized :label="$t('ФИО')" v-model="guest.name" :original_value="original_value.name" :rule="[rules.required, rules.nameRule(2)]"/>
                        <TextField hint @focus.prevent="e => $store.dispatch('inputFocus', e)" kbd-capitalized :label="$t('E-mail')" v-model="guest.email" :original_value="original_value.email" :rule="[rules.emailRule]"/>
                        <TextField @focus.prevent="e => $store.dispatch('inputFocus', e)" kbd-capitalized :label="$t('Доп.инфо')" v-model="guest.extra" :original_value="original_value.extra"/>
                    </v-form>
                </v-col>
                <v-col>
                    <ListItemsController
                        allow_create
                        :allow_delete="guest.phones.length != 1"

                        :label="$t('Номера телефона гостя')"
                        :original_value="original_value.phones"
                        :default_item="{
                            number:''
                        }"
                        v-if="guest.phones"
                        v-model="guest.phones"
                    >
                        <template #list-item="{item}">
                            <v-list-item test-tag="tag-59">
                                <v-list-item-avatar><v-icon>mdi-phone</v-icon></v-list-item-avatar>
                                <v-list-item-content>
                                    <PhoneFormatter v-model="item.number"/>
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                        <template #dialog="{item, is_new, submit}">
                            <v-card>
                                <v-card-title test-tag="tag-61">
                                    <T :key="1" v-if="is_new">Добавление номера телефона</T>
                                </v-card-title>
                                <v-form @submit.prevent="submit" v-model="phone_valid">
                                    <v-card-text>
                                        <PhoneField v-model="item.number"
                                            @input="debounceInput"
                                            :label="$t('Номер телефона')"
                                            :rules="[rules.phoneRule]"
                                        >
                                        </PhoneField> 
                                        <p v-if="is_phone_exist" class="error--text"><T>Данный номер привязан к другому гостю. Хотите привязать данный номер телефона к гостю?</T></p>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn test-tag="tag-56" text color="primary" type="submit" :disabled="!phone_valid"><v-icon>mdi-check</v-icon><T>Готово</T></v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </template>
                        
                    </ListItemsController>
                </v-col>
            </v-row>
            <hr>
            <v-row class="mt-1">
                <v-col>
                    <ListItemsController
                        allow_create
                        allow_edit
                        allow_delete
                        
                        :label="$t('Адреса доставки')"
                        :original_value="original_value.addresses"
                    
                        v-model="guest.addresses" 
                    >
                        <template #list-item="{item}">
                            <v-list-item test-tag="tag-60">
                                <v-list-item-avatar><v-icon>mdi-map-marker-outline</v-icon></v-list-item-avatar>
                                <v-list-item-content>
                                    {{ item.value }}
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                        <template #dialog="{item, is_new, submit, remove}">
                            <v-card>
                                <v-card-title test-tag="tag-62">
                                    <T :key="1" v-if="is_new">Добавление адреса доставки</T>
                                    <T :key="2" v-else>Редактирование адреса доставки</T>
                                </v-card-title>
                                <v-form @submit.prevent="() => { item.value = address_fill.value; address_fill = {}; submit()}" v-model="address_valid">
                                    <v-card-text>
                                        <AddressSuggestionField v-if="$store.getters.local_refs.geocoding.enabled" v-model="address_fill" :label="$t('Адрес доставки')" :rules="[rules.required]"/>
                                        <!-- <AddressSuggestionField v-if="$store.getters.local_refs.geocoding.enabled" allow-inexact v-model="item[idx]" :label="$t('Адрес доставки')"/> -->
                                        <TextField v-else :label="'Адрес доставки'" v-model="address_fill" :rules="[rules.required]"/>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn test-tag="tag-57" text color="secondary" v-if="!is_new" type="button" @click="remove"><v-icon>mdi-delete</v-icon><T>Удалить</T></v-btn>
                                        <v-btn test-tag="tag-58" text color="primary" :disabled="!address_valid || !Object.keys(address_fill).length" type="submit"><v-icon>mdi-check</v-icon><T>Готово</T></v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </template>
                        
                    </ListItemsController>
                </v-col>
            </v-row>
        </v-card-text>
        <v-row align="center" justify="center" v-else>
            <v-progress-circular size="100" indeterminate color="primary" ></v-progress-circular>
        </v-row>
    </div>
</template>

<script>
import Teleport from 'vue2-teleport'
import PhoneFormatter from '@/components/common/PhoneFormatter.vue'
import PhoneField from '@/components/common/PhoneField.vue'
import ListItemsController from '@/components/common/ListItemsController.vue'
import deleteGuestDialog from './deleteGuestDialog.vue'
import TextField from '@/components/common/TextField.vue'
import AddressSuggestionField from '../../common/AddressSuggestionField.vue'

import rules_mixin from '@/components/common/rules_mixin.js'
import _ from 'lodash'

export default{
    mixins: [rules_mixin],
    props: ['value'],
    data:()=>({
        loading: false,
        original_value:{},
        new_phone: '',
        is_phone_exist: false,
        phone_valid: false,
        guest_info_valid: null,
        address_valid: false,
        address_fill: {}
    }),
    computed:{
        guestId(){
            return this.$route.params.guestId
        },

        guest: {
            set(v){ this.$emit(v) },
            get(){ return this.value }
        }
    },
    methods:{
        debounceInput: _.debounce(function(val){
                this.check_phone({number: val})
            }, 1000
        ),
        async saveGuest(){
            await this.$store.dispatch('updateGuest', this.guest)
            this.original_value={...this.$store.getters.guest_by_id(this.guestId)}

            this.$store.dispatch('throwTimeoutMessage', {
                message_data: 'Успешно обновлено',
                message_class: 'success'
            })
        },
        async deleteGuest(){
            await this.$store.dispatch('deleteGuestById', this.guestId)
            this.$router.replace({path: '/guests/'})
        },
        async check_phone(val){
            let checked = await this.$store.dispatch('checkPhone', val)
            this.is_phone_exist = checked.phone_exist
        },
        async blockGuest(){
            this.guest.black_list = !this.guest.black_list

            if(!this.guest.black_list)
                this.guest.block_reasons = ""

            await this.$store.dispatch('blockGuest', this.guest)

            this.original_value={...this.$store.getters.guest_by_id(this.guestId)}
        },
    },
    async mounted(){
        this.loading = false
        this.original_value = {...this.guest}
        this.loading = true
    },
    components:{
        Teleport,
        ListItemsController,
        PhoneFormatter,
        PhoneField,
        deleteGuestDialog,
        AddressSuggestionField,
        TextField,
    }
}
</script>